import { Button, Space, Tag, TreeSelect } from "antd";
import layoutStorage from "../storages/layout-storage";
import { PlusOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import partTypesStorage from "../storages/part-types";
import PartTypesDialog from '../pages/settings-page/components/part-types-dialog';

/* eslint-disable-next-line */
export interface PartTypeSelectorProps {
  partType: string[];
  onChange: (value: string[]) => void;
}

export function PartTypeSelector({ partType, onChange }: PartTypeSelectorProps) {
  const [isEdit, setIsEdit] = React.useState(false);
  const {
    isAddPartTypeModalOpened,
    toggleAddPartTypeModalDialog,
    closeAddPartTypeModalDialog,
  } = layoutStorage;
  const { partTypes, loadPartTypes } = partTypesStorage;

  useEffect(() => {
    loadPartTypes()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddPartTypeModalOpened]);

  return (
    <>
      {(isEdit || !partType?.length) && (
        <Space>
          <TreeSelect
            style={{ width: '100%', minWidth: 250 }}
            placeholder="Select/enter category"
            showSearch
            value={partType}
            loadData={async () => { return loadPartTypes(); }}
            tagRender={(props) => {
              const [category] = props.value?.split(':') || ['',''];
              const partType = partTypes.find((partType) => partType.key === category);
              const subPartType = partType?.subcategories?.find((subPartType) => subPartType.key === props.value);
              return <Tag
                closable={props.closable}
                onClose={props.onClose}
                style={{ marginRight: 3 }}
              >
                {partType?.name}
                {'->'}
                {subPartType?.name}
              </Tag>;
            }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeDefaultExpandAll
            multiple
            treeCheckable
            popupClassName={'g-select'}
            treeData={partTypes.map((partType) => ({
              title: partType.name,
              value: partType.key,
              children: partType.subcategories?.map((subPartType) => ({
                title: subPartType.name,
                value: subPartType.key,
              })),
            }))}
            onChange={(value: string[]) => {
              onChange(value);
            }}
            onBlur={() => {
              setIsEdit(() => false);
            }}
            onSelect={(value) => {
              console.log('selected', value);
            }}
          />
          <Button
            type="link"
            icon={<PlusOutlined />}
            onClick={() => {
              toggleAddPartTypeModalDialog();
            }}
            style={{ marginLeft: 5 }}
          >
            Add
          </Button>
        </Space>
      )}
      {!isEdit && partType.map((currentPartType) => {
        const [category] = currentPartType.split(':') || ['',''];
        const partType = partTypes.find((partType) => partType.key === category);
        const subPartType = partType?.subcategories?.find((subPartType) => subPartType.key === currentPartType);
        return <Tag
          closable={false}
          style={{ marginRight: 3 }}
          onClick={() => setIsEdit(true)}
        >
          {partType?.name}
          {'->'}
          {subPartType?.name}
        </Tag>;
      })}

      <PartTypesDialog
        onClose={() => {
          partTypesStorage.loadPartTypes();
          closeAddPartTypeModalDialog();
        }}
      />

      {/*<AddPartTypeDialog*/}
      {/*  parentKey={""}*/}
      {/*  opened={isAddPartTypeModalOpened}*/}
      {/*  onToggle={toggleAddPartTypeModalDialog}*/}
      {/*  onSelect={(partTypeId: string[]) => onChange(partTypeId)}*/}
      {/*/>*/}
    </>
  );
}

export default observer(PartTypeSelector);
